<template>
  <v-data-table
    :headers="headers"
    :items="items"
    hide-default-footer
    :items-per-page="500"
    class="custom-bordered-table"
    :class="{'no-border-top': index != 0, 'fixedHeaders': currentForm.fixedHeaders && !isPdfMode}"
  >
    <template #headers>
      <tr>
        <th
          v-for="(group, i) in groupHeaders"
          :key="'group-' + i"
          :colspan="group.colspan"
          :rowspan="group.rowspan"
          class="text-center header-title"
          :class="{'no-bottom-border': subHeaders?.length }"
          :style="{ width: normalizeWidth(group.width) }"
        >
          <p v-html="group.title"></p>
        </th>
      </tr>
      <tr v-if="subHeaders?.length">
        <th
          v-for="(sub, i) in subHeaders"
          :key="'sub-' + i"
          class="text-center header-title"
          :style="{ width: normalizeWidth(sub.width) }"
        >
        <p v-html="sub.title"></p>
        </th>
      </tr>
    </template>

    <template #item="{ item }">
      <tr v-if="item.cells">
        <template v-for="header in flatHeaders" :key="header.key">
          <template v-if="item.cells[header.key]">
            <template v-if="item.cells[header.key].innerCells">
              <td
                :colspan="normalizeColSpans(item.cells, flatHeaders)[header.key].colSpan"
                :style="{ width: normalizeWidth(item.cells[header.key].width || header.width) }"
                class="table-cell name-cell inner-cell-group"
                :class="{'text-center': item.cells[header.key].align == 'center'}"
              >
                <div class="d-flex" style="gap: 8px">
                  <template
                    v-for="(subCell, subKey) in item.cells[header.key].innerCells"
                    :key="subKey"
                  >
                    <div style="flex: 1; display: flex; align-items: center;" class="inner-cell">
                      <v-text-field
                        v-if="subCell.type === 'text-input' && data[subCell.name] !== undefined && !isPdfMode"
                        :value="data[subCell.name]"
                        @update:modelValue="value =>
                          $emit('update:data', { ...data, [subCell.name]: value })
                        "
                        
                        :placeholder="subCell.placeholder"
                        :disabled="subCell.disabled"
                        variant="outlined"
                        density="compact"
                        hide-details
                        :type="currentForm?.strings?.includes(header.key) ? 'string' : 'number'"
                      />
                      <v-text-field
                        v-else-if="subCell.type === 'text-input' && !isPdfMode"
                        :placeholder="subCell.placeholder"
                        :disabled="subCell.disabled"
                        variant="outlined"
                        density="compact"
                        hide-details
                        :type="currentForm?.strings?.includes(header.key) ? 'string' : 'number'"
                      />
                          
                      <v-autocomplete
                        v-if="subCell.type === 'select' && data[subCell.name] !== undefined && !isPdfMode"
                        :value="data[subCell.name]"
                        @update:modelValue="value => handleSelectChange(value, item, header)"
                        :items="distionaryItems[item.cells[header.key].code]"
                        :item-title="item => item.shortForm"
                        :item-value="item => item.shortForm"
                        :placeholder="subCell.placeholder"
                        variant="outlined"
                        density="compact"
                        hide-details
                      />
                      <v-autocomplete
                        v-else-if="subCell.type === 'select' && !isPdfMode"
                        :items="distionaryItems[item.cells[header.key].code]"
                        :item-title="item => item.shortForm"
                        :item-value="item => item.shortForm"
                        :placeholder="subCell.placeholder"
                        variant="outlined"
                        density="compact"
                        hide-details
                      />
                      <p v-if="subCell.type === 'text'" v-html="subCell.value"></p>
                      <p v-if="subCell.type === 'calculated'">
                        {{ calculateValue(subCell, data, true, val => $emit('update:data', val)) }}
                      </p>
                      <p v-if="isPdfMode":key="data[subCell.name]">{{ data[subCell.name] }}</p>
                    </div>
                  </template>
                </div>
              </td>
            </template>
            <td
              v-else
              :colspan="normalizeColSpans(item.cells, flatHeaders)[header.key].colSpan"
              :style="{ width: normalizeWidth(item.cells[header.key].width || header.width) }"
              class="table-cell name-cell"
              :class="{'text-center': item.cells[header.key].align == 'center'}"
            >
            <p v-if="getConfig?.developerMode">{{ item.cells[header.key].name }} </p>
              <v-text-field
                :type="currentForm?.strings?.includes(header.key) ? 'string' : 'number'"
                v-if="item.cells[header.key].type === 'text-input' && data[item.cells[header.key].name] !== undefined && !isPdfMode"
                :value="data[item.cells[header.key].name]"
                @update:modelValue="value =>
                  $emit('update:data', { ...data, [item.cells[header.key].name]: value })
                "
                :placeholder="item.cells[header.key].placeholder"
                :disabled="isCellDisabled(item.cells[header.key]) || (item.cells[header.key].disabledAfterFirst && $route.query.instanceId)"
                :required="item.cells[header.key].required"
                variant="outlined"
                density="compact"
                hide-details
              />
              <v-text-field
                v-else-if="item.cells[header.key].type === 'text-input' && !isPdfMode"
                :placeholder="item.cells[header.key].placeholder"
                :disabled="isCellDisabled(item.cells[header.key]) || (item.cells[header.key].disabledAfterFirst && $route.query.instanceId)"
                :required="item.cells[header.key].required"
                variant="outlined"
                density="compact"
                hide-details
                :type="currentForm?.strings?.includes(header.key) ? 'string' : 'number'"
              />
              <date-picker-field
                v-if="item.cells[header.key].type === 'date' && !isPdfMode"
                :model-value="data[item.cells[header.key].name]"
                @update:modelValue="value => $emit('update:data', { ...data, [item.cells[header.key].name]: value })"
                :disabled="isCellDisabled(item.cells[header.key])"
                :is-required="item.cells[header.key].required"
              />
              <v-autocomplete
                v-if="item.cells[header.key].type === 'select'
                  && data[item.cells[header.key].name] !== undefined
                  && !isPdfMode"
                v-model="data[item.cells[header.key].name]"
                variant="outlined"
                density="compact"
                hide-details
                :placeholder="item.cells[header.key].placeholder"
                :items="distionaryItems[item.cells[header.key].code] || []"
                item-title="shortForm"
                item-value="shortForm"
                @update:modelValue="value => handleSelectChange(value, item, header, item.cells[header.key])"
              >
              </v-autocomplete>
              <v-autocomplete
                v-else-if="item.cells[header.key].type === 'select' && !isPdfMode"
                :items="distionaryItems[item.cells[header.key].code]"
                :item-title="item => item.shortForm"
                :item-value="item => item.shortForm"
                :placeholder="item.cells[header.key].placeholder"
                variant="outlined"
                density="compact"
                hide-details
              ></v-autocomplete>
              <p v-if="item.cells[header.key].type === 'text'" v-html="item.cells[header.key].value"></p>
              <p v-if="item.cells[header.key].type === 'calculated'">
                {{ calculateValue(item.cells[header.key], data, true, val => $emit('update:data', val)) }}
              </p>
              <p v-if="isPdfMode && item.cells[header.key].type != 'text' && item.cells[header.key].type != 'calculated'">{{ data[item.cells[header.key].name] }}</p>
              <div v-else-if="item.cells[header.key].type == 'action' && isShow(item)">
                 <v-btn color="blue-darken-3" @click="delString(item)">
                    <v-icon>mdi-minus</v-icon>
                 </v-btn>
              </div>
            </td>
          </template>
        </template>
      </tr>
      <tr v-else-if="item['actions']">
         <td :colspan="flatHeaders?.length" class="subheader-cell">
          <v-btn color="blue-darken-3" @click="addString(item['actions'])">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </td>
      </tr>

      <tr v-else-if="item['table-subheader']">
        <td :colspan="item['colSpan'] || flatHeaders?.length" class="subheader-cell">
          {{ item["table-subheader"] }}
        </td>
        <td
          :colspan="flatHeaders?.length - item['colSpan']"
          class="subheader-cell empty"
          v-if="item['colSpan'] && item['colSpan'] <= flatHeaders?.length"
        ></td>
      </tr>

      <tr v-else-if="item['table-header']">
        <td :colspan="item['colSpan'] || flatHeaders?.length" class="header-cell">
          {{ item["table-header"] }}
        </td>
        <td
          :colspan="flatHeaders?.length - item['colSpan']"
          class="subheader-cell empty"
          v-if="item['colSpan'] && item['colSpan'] <= flatHeaders?.length"
        ></td>
      </tr>
    </template>

  </v-data-table>
</template>

<script>
import plicanteRequestService from '@/services/plicante.request.service';
import { mapGetters } from 'vuex';
import DatePickerField from './DatePickerField.vue';


export default {
  name: 'CustomDataTable',
  components: { DatePickerField },
  props: {
    headers: Array,
    items: Array,
    allItems: Array,
    data: Object,
    isPdfMode: Boolean,
    index: {
      type: Number,
      default: 0
    },
    currentForm: Object,
  },
  data() {
    return {
      distionaryItems: {},
      distionaryItemsLength: {},
      distionaryItemsOffSet: {}
    }
  },
  emits: ['update:data', 'update:dictionaries'],
  methods: {
    isCellDisabled(cell) {
      if (cell?.disabled) return true
      if (!cell?.enabledWhen) return false

      const condition = cell.enabledWhen
      const selectedValue = this.data[condition.field]
      if (condition.itemId !== undefined) {
        const selectedItem = (this.distionaryItems[condition.code] || [])
          .find(item => item.shortForm === selectedValue)
        return String(selectedItem?.id) !== String(condition.itemId)
      }

      return selectedValue !== condition.value
    },
    normalizeWidth(width) {
      if (width === undefined || width === null || width === '') return undefined

      const value = String(width).trim()
      return /^\d+(\.\d+)?$/.test(value) ? `${value}px` : value
    },
    // updatePage(i, code) {
    //  this.getItemsForDictionary(code, null, i)
    // },
    // updateDictionary(i, code) {
    //   this.tableObjectAttributes[0].attributeValueTypes.forEach(item => {
    //     console.log(item, code, this.tableObjectAttributes[0])
    //     if (item.code == code) {
    //       this.getItemsForDictionary(item, item.code, i)
    //     }
    //  })
    // },
    handleSelectChange(value, item, header, field) {
      const cell = item.cells[header.key];
      if (!cell || !cell.name) return;

      const updatedData = {
        ...this.data,
        [cell.name]: value
      }

      if (field.relatedWithCode) {
        Object.values(item.cells).forEach(rowCell => {
          if (rowCell.code === field.relatedWithCode) {
            updatedData[rowCell.name] = null
          }
        })
      }

      this.$emit("update:data", updatedData)
      this.onSelectChange(field)
    },
    onSelectChange(field) {
      if (field.relatedWithCode) {
        // this.getValuesForManaged()
        // const meta = this.metaAttributesData.find(m => m.code?.trim() === field.code?.trim())
        let currentItem = this.distionaryItems[field.code.trim()]?.find(el => el.shortForm == this.currentForm.data[field.name]);

        if (!currentItem?.attributeValueTypes?.length) {
          this.nullItemsForDictionary(field.relatedWithCode)
          return
        }

        currentItem.attributeValueTypes.forEach(el => {
          if (el.code == 'managed_dictionary') {
            const id = el.value.dataList[0]?.data?.memberId;
            this.getItemsForDictionary(id, field.relatedWithCode)
          }
        })
      }
    },
    getAllDicts() {
      if (this.currentForm?.dirs) {
        this.currentForm.dirs.forEach(el => {
        this.getItemsForDictionary(el)
      })
      }
    },
    getItemsForDictionary(id, code, offSet = 0) {
      const payload = {
        "tablePageType": {
          "menuItemType": {
            "id": id
            },
            "offSet": offSet,
            "pageSize": -1,
            "getLinkedWithOwner": "true"
        },
        "filterType": {
          "owner": {
              "templateId": 79909,
          }
        }
      }
      const url = `${process.env.VUE_APP_BASE_URL}/register-rest/operator/countedTableAttributes/search`
      plicanteRequestService.post(url, payload)
      .then(data => {
        data.data.tableObjectAttributes = data.data.tableObjectAttributes.filter(el => el.shortForm.length > 0)
        const dictionaryKey = `${code ? code : id}`
        const dictionaryItems = [{shortForm: '--', id: null}, ...data.data.tableObjectAttributes]

        this.distionaryItems[dictionaryKey] = dictionaryItems
        this.distionaryItemsLength[dictionaryKey] = Math.ceil(data.data.count / 10);
        this.distionaryItemsOffSet[dictionaryKey] = offSet;
        this.$emit('update:dictionaries', { [dictionaryKey]: dictionaryItems })
        // this.currentForm.sections.forEach(el => {
        //   el.rows.forEach(row => {
        //     if (row.cells) {
        //       for (let cell of Object.values(row.cells)) {
        //         if (cell.relatedWithCode) {
        //           let currentItem = this.distionaryItems[cell.code.trim()]?.find(el => el.shortForm == this.currentForm.data[cell.name]);
        //           console.log(this.distionaryItems)
        //           currentItem.attributeValueTypes.forEach(el => {
        //             if (el.code == 'managed_dictionary') {
        //               const id = el.value.dataList[0]?.data?.memberId;
        //               this.getItemsForDictionary(id, cell.relatedWithCode)
        //             }
        //           })
        //         }
        //       }
        //     }
        //   })
        // })
      })
      .catch(err => {
        console.log(err)
      })
    },
    nullItemsForDictionary(code){
      if (!code) return

      this.distionaryItems[code] = []
      this.distionaryItemsLength[code] = 0
      this.distionaryItemsOffSet[code] = 0
    },
    isShow(row) {
      const cells = row.cells || row;

      const firstKey = Object.keys(cells).find(
        k => cells[k] && cells[k].name
      );
      if (!firstKey) return false;

      const name = cells[firstKey].name; // value_1_1_1
      const parts = name.split("_");
      if (parts.length !== 4) return false;

      const tableIndex = Number(parts[1]);

      // Находим таблицу
      const table = this.currentForm.sections.find(
        s => s.type === "table" && s.tableId === tableIndex
      );
      if (!table) return false;

      // Берём только строки с cells (динамические строки)
      const filteredRows = table.rows.filter(r => r.cells);

      if (filteredRows.length <= 1) {
        return false; // показывать нечего
      }

      // Проверяем, является ли текущая строка последней
      const lastRow = filteredRows[filteredRows.length - 1];

      return lastRow === row;
    },
    addString(tableIndex) {
      const table = this.currentForm.sections.find(
        s => s.type === "table" && s.tableId === tableIndex
      )
      if (!table) return

      const dynamicRows = table.rows.filter(r => r.cells)
      const lastRow = dynamicRows[dynamicRows.length - 1]
      if (!lastRow) return

      const anyCellName = Object.values(lastRow.cells)[0]?.name
      if (!anyCellName) return

      const parts = anyCellName.split("_")
      const prevRowNumber = Number(parts[2])
      const rowNumber = prevRowNumber + 1
      const tableNumber = parts[1]

      const getCodeNum = (v) => {
        if (typeof v !== "string") return null
        const m = v.match(/^code_(\d+)$/)
        return m ? Number(m[1]) : null
      }

      const getMaxCodeNumInTable = () => {
        let max = 0
        const rows = table.rows || []
        rows.forEach(r => {
          if (!r?.cells) return
          Object.values(r.cells).forEach(c => {
            const n1 = getCodeNum(c?.code)
            const n2 = getCodeNum(c?.relatedWithCode)
            if (n1 != null && n1 > max) max = n1
            if (n2 != null && n2 > max) max = n2
          })
        })
        return max
      }

      const collectCodesInRowInOrder = (row) => {
        const seen = new Set()
        const ordered = []
        const keys = Object.keys(row.cells)
        keys.forEach(k => {
          const c = row.cells[k]
          const v1 = c?.code
          const v2 = c?.relatedWithCode
          if (typeof v1 === "string" && /^code_\d+$/.test(v1) && !seen.has(v1)) {
            seen.add(v1)
            ordered.push(v1)
          }
          if (typeof v2 === "string" && /^code_\d+$/.test(v2) && !seen.has(v2)) {
            seen.add(v2)
            ordered.push(v2)
          }
        })
        return ordered
      }

      const maxCode = getMaxCodeNumInTable()
      const codesInLastRow = collectCodesInRowInOrder(lastRow)

      const codeMap = codesInLastRow.reduce((acc, oldCode, idx) => {
        acc[oldCode] = `code_${maxCode + idx + 1}`
        return acc
      }, {})

      const remap = (v) => (typeof v === "string" && codeMap[v]) ? codeMap[v] : v

      const newRow = { cells: {} }
      const columnKeys = Object.keys(lastRow.cells)

      columnKeys.forEach((colKey, index) => {
        const oldCell = lastRow.cells[colKey]
        const newCellName = `value_${tableNumber}_${rowNumber}_${index + 1}`

        let newFormula = oldCell.formula
        if (newFormula) {
          const regex = new RegExp(`value_${tableNumber}_${prevRowNumber}_`, "g")
          newFormula = newFormula.replace(regex, `value_${tableNumber}_${rowNumber}_`)
        }

        const newCell = {
          ...oldCell,
          name: newCellName,
          formula: newFormula
        }

        if (oldCell.enabledWhen?.field) {
          newCell.enabledWhen = {
            ...oldCell.enabledWhen,
            field: oldCell.enabledWhen.field.replace(
              `value_${tableNumber}_${prevRowNumber}_`,
              `value_${tableNumber}_${rowNumber}_`
            )
          }
        }

        if (newCell.code) newCell.code = remap(newCell.code)
        if (newCell.relatedWithCode) newCell.relatedWithCode = remap(newCell.relatedWithCode)

        newRow.cells[colKey] = newCell

        const defaultKey = `default_${tableNumber}_*_${index + 1}`
        const defaultValue = this.currentForm.data[defaultKey]
        const initialValue = defaultValue !== undefined ? defaultValue : null

        this.data[newCellName] = initialValue
        this.currentForm.data[newCellName] = initialValue
      })

      const actionsIndex = table.rows.findIndex(r => r.actions)
      table.rows.splice(actionsIndex, 0, newRow)
    },

    delString(row) {
      // row = { cells: { mod1: {...}, mod2: {...}, ... } } или сразу cells
      const cells = row.cells || row;

      // Берём любой cell с name
      const firstKey = Object.keys(cells).find(
        k => cells[k] && cells[k].name
      );
      if (!firstKey) return;

      const name = cells[firstKey].name; // "value_1_1_1" и т.п.
      const parts = name.split("_");     // ["value","1","1","1"]

      if (parts.length !== 4) return;

      const tableIndex = Number(parts[1]);   // 1 — номер таблицы / tableId
      const rowToDelete = Number(parts[2]);  // 1 — номер строки

      // 1. Находим таблицу в currentForm.sections
      const table = this.currentForm.sections.find(
        s => s.type === "table" && s.tableId === tableIndex
      );
      if (!table) return;

      // 2. Находим индекс строки в table.rows по номеру строки
      const rowIndexInTable = table.rows.findIndex(r => {
        if (!r.cells) return false;

        const anyKey = Object.keys(r.cells).find(
          k => r.cells[k] && r.cells[k].name
        );
        if (!anyKey) return false;

        const nm = r.cells[anyKey].name;   // "value_1_3_1"
        const p = (nm || "").split("_");
        if (p.length !== 4) return false;

        const rNum = Number(p[2]);
        return rNum === rowToDelete;
      });
      console.log(table.rows[rowIndexInTable])

      if (rowIndexInTable === -1) return;

      // 3. Удаляем строку из таблицы
      table.rows.splice(rowIndexInTable, 1);

      // 4. Удаляем ВСЕ значения этой строки из currentForm.data
      Object.keys(this.currentForm.data).forEach(key => {
        const pp = key.split("_");
        if (pp.length === 4) {
          const tIdx = Number(pp[1]);
          const rNum = Number(pp[2]);

          if (tIdx === tableIndex && rNum === rowToDelete) {
            delete this.currentForm.data[key];
          }
        }
      });

      // 5. Перенумеровываем оставшиеся строки: value_1_1_*, value_1_2_*, ...
      const dynamicRows = table.rows.filter(r => r.cells);

      dynamicRows.forEach((r, newIndex) => {
        const newRowNum = newIndex + 1; // 1,2,3,...

        Object.entries(r.cells).forEach(([colKey, cell], colIndex) => {
          console.log(colKey)
          if (!cell || !cell.name) return;

          const oldName = cell.name;                  // value_1_4_3
          const newName = `value_${tableIndex}_${newRowNum}_${colIndex + 1}`;

          if (oldName === newName) return;

          // Обновляем имя в JSON
          cell.name = newName;

          // Перекладываем данные в currentForm.data
          if (oldName in this.currentForm.data) {
            this.currentForm.data[newName] = this.currentForm.data[oldName];
            delete this.currentForm.data[oldName];
          } else {
            // Если старого значения нет, создаём пустое поле
            if (!(newName in this.currentForm.data)) {
              this.currentForm.data[newName] = null;
            }
          }
        });
      });
    },
    normalizeColSpans(cells, headers) {
      const totalCols = headers?.length;
      const keys = headers.map(h => h.key);

      let usedCols = 0;
      const missingKeys = [];

      for (const key of keys) {
        const colSpan = cells[key]?.colSpan;
        if (typeof colSpan === 'number' && colSpan > 0) {
          usedCols += colSpan;
        } else if (cells[key] && cells[key].type) {
          missingKeys.push(key);
        }
      }

      const remainingCols = Math.max(totalCols - usedCols, 0);
      const autoColSpan = missingKeys?.length ? Math.floor(remainingCols / missingKeys?.length) : 1;
      const extra = missingKeys?.length ? remainingCols % missingKeys?.length : 0;

      const normalized = {};
      let distributed = 0;

      for (const key of keys) {
        if (typeof cells[key]?.colSpan === 'number' && cells[key].colSpan > 0) {
          normalized[key] = { ...cells[key], colSpan: cells[key].colSpan };
        } else if (cells[key] && cells[key].type) {
          let colSpan = autoColSpan;
          if (distributed < extra) {
            colSpan += 1;
            distributed += 1;
          }
          normalized[key] = { ...cells[key], colSpan };
        } else {
          normalized[key] = { ...cells[key], colSpan: 0 };
        }
      }

      return normalized;
    },
    calculateValue(cell, data, update = false, updateFn = null) {
      const invalidate = () => {
        if (update && typeof updateFn === "function" && cell && cell.name) {
          const current = data[cell.name]
          if (current !== null && current !== undefined && current !== "") {
            updateFn({ ...data, [cell.name]: null })
          }
        }
        return "—"
      }

      try {
        let formula = cell.formula || ""
        const precision = cell.precision ?? 2

        formula = formula.replace(/sum\(\s*([a-zA-Z0-9_*]+)\s*\)/g, (match, pattern) => {
          const regexStr = "^" + pattern.replace(/\*/g, ".*") + "$"
          const regex = new RegExp(regexStr)
          const matchedKeys = Object.keys(data).filter(k => regex.test(k))

          const sum = matchedKeys.reduce((acc, key) => {
            const num = Number(data[key])
            return Number.isFinite(num) ? acc + num : acc
          }, 0)

          return sum
        })

        const varNames = Array.from(new Set(formula.match(/[a-zA-Z_]\w*/g) || []))
        const values = new Array(varNames.length)

        for (let i = 0; i < varNames.length; i++) {
          const name = varNames[i]
          const raw = data[name]
          const num =
            raw === undefined || raw === ""
              ? 0
              : Number(raw)

          if (!Number.isFinite(num)) return invalidate()
          values[i] = num
          // const num = Number(raw)
          if (!Number.isFinite(num)) return invalidate()
          values[i] = num
        }

        const fn = new Function(...varNames, `return ${formula};`)
        const rawResult = fn(...values)
        if (typeof rawResult !== "number" || !Number.isFinite(rawResult)) return invalidate()

        const result = Number(rawResult.toFixed(precision))

        if (update && typeof updateFn === "function" && cell && cell.name && data[cell.name] !== result) {
          updateFn({ ...data, [cell.name]: result })
        }

        if (cell.format === "percentage") return `${result.toFixed(precision)}%`

        return result
      } catch (e) {
        return invalidate()
      }
    },
  },
  computed: {
    ...mapGetters(['getConfig']),
    innerHeaders() {
      let innerHeaders = false
      this.headers.forEach(el => {
        if (el.innerHeaders) {
          innerHeaders = true
        }
      })
      return innerHeaders
    }, 
    groupHeaders() {
      return this.headers.map((col) => {
        if (col.innerHeaders) {
          return {
            title: col.title,
            colspan: col.headers?.length,
            rowspan: 1,
            width: col.width,
            code: col.code || null,
            relatedWithCode: col.relatedWithCode || null,
          }
        }
        return {
          title: col.title,
          colspan: 1,
          rowspan: this.innerHeaders ? 2 : 1,
          width: col.width,
          code: col.code || null,
          relatedWithCode: col.relatedWithCode || null,
        }
      })
    },

    subHeaders() {
      return this.headers
        .filter((col) => col.innerHeaders)
        .flatMap((col) => col.headers)
    },
    flatHeaders() {
      return this.headers.flatMap(header => {
        if (header.innerHeaders && header.headers) {
          return header.headers
        }
        return [header]
      })
    }
  },
  mounted() {
    this.getAllDicts()
  }
}
</script>

<style scoped>
  .custom-bordered-table table {
    border-collapse: collapse;
    width: 100%;
  }
  .custom-bordered-table {
    border-collapse: collapse;
    width: 100%;
  }

  .custom-bordered-table.fixedHeaders {
    height: calc(100dvh - 400px);
    min-height: 250px;
  }

  .custom-bordered-table.fixedHeaders :deep(thead) {
    position: sticky;
    top: 0;
    background: var(--app-surface);
    z-index: 100;
  }

  .table-cell {
    border: 1px solid var(--app-border);
    border-right: none;
    width: 362px;
    padding: 0;
  }

  .table-cell:last-child {
    border-right: 1px solid var(--app-border);
  }

  .subheader-cell {
    border: 1px solid var(--app-border);
    width: 362px;
    text-align: center;
    font-style: italic;
    border-top: none
  }

  .header-cell {
    border: 1px solid var(--app-border);
    width: 362px;
    text-align: center;
    font-weight:900;
    font-style: italic;
    border-top: none;
    font-size: 15px;
  }

  .cell-content {
    display: flex;
    align-items: center;
    height: 100%;
    padding: 4px 8px;
  }

  .name-cell {
    width: 362px;
    border-top: none 
  }

  .cell-content {
    display: flex;
    align-items: center;
    height: 100%;
    padding: 4px 8px;
  }

  .name-cell {
    width: 362px;
  }

  .name-cell:not(:last-child) {
    border-right: none; 
  }

  .header-title {
    font-weight: bold!important;
    justify-content: center;
  }

  .no-bottom-border {
    border-bottom: none!important;
  }

  .year__label {
    font-weight: bold;
    font-size: 13px;
  }

  .no-border-top th{
    border-top: none!important
  }

  .inner-cell-wrapper {
    display: flex;
    width: 100%;
    gap: 8px;
    height: 100%;
  }

  .inner-cell {
    display: flex;
    align-items: center;
    flex: 1;
    border-right: 1px solid var(--app-border);
    min-height: 52px;
  }

  .inner-cell:last-child {
    border-right: none;
  }

  .inner-cell:not(:last-child) {
    padding-right: 10px;
  }

  .empty {
    border-left: none
  }

  @media (max-width: 480px) {
    .custom-bordered-table {
      max-width: 100%;
    }

    .custom-bordered-table.fixedHeaders {
      height: min(52svh, 420px);
    }

    .custom-bordered-table :deep(.v-table__wrapper) {
      overflow-x: auto;
      overscroll-behavior-inline: contain;
      -webkit-overflow-scrolling: touch;
    }

    .custom-bordered-table :deep(table) {
      width: max-content;
      min-width: 100%;
    }

    .custom-bordered-table :deep(.v-input) {
      min-width: 120px;
    }
  }
</style>
